import messageTemplateActionsTypes from "../actions/messageTemplateActionsTypes";
import { reducerFactory } from "./reducerFactory";

export const messageTemplateReducer = reducerFactory.crudReducer(
  messageTemplateActionsTypes
);
